import { Button, Loading, Typography } from "@/components/atoms";
import { useApproveInvitationMutation, useRejectInvitationMutation } from "@/redux/apis/network/networkApi";
import { NetworkItem } from "@/redux/slices/network/types";
import { addToast, getAssetUrl } from "@/utils";
import { getErrorMessages } from "@/helpers/reduxHelpers";

interface ReceivedInvitationBannerProps {
  item: NetworkItem;
}

export const ReceivedInvitationBanner = ({ item }: ReceivedInvitationBannerProps) => {
  const [approve, { isLoading: isApproving }] = useApproveInvitationMutation();
  const [reject, { isLoading: isRejecting }] = useRejectInvitationMutation();
  const isLoading = isApproving || isRejecting;

  const handleAccept = () => {
    approve(item.id)
      .unwrap()
      .then(() => addToast("success", "Successfully accepted invitation"))
      .catch((e) => getErrorMessages(e).forEach((m) => addToast("danger", m)));
  };

  const handleDecline = () => {
    reject(item.id)
      .unwrap()
      .then(() => addToast("success", "Successfully declined invitation"))
      .catch((e) => getErrorMessages(e).forEach((m) => addToast("danger", m)));
  };

  return (
    <div className="relative flex items-center justify-between rounded-lg border border-neutral-mid-gray bg-neutral-surface-gray px-4 py-3">
      {isLoading && <Loading className="absolute inset-0 z-10 flex items-center justify-center rounded-lg bg-white/60" />}
      <div className="flex items-center gap-2.5">
        {item.operator.assetsCdn.emblem ? (
          <img src={getAssetUrl(item.operator.assetsCdn.emblem)} className="h-6 w-6" />
        ) : (
          <div className="h-6 w-6 rounded-full bg-neutral-mid-gray" />
        )}
        <Typography variant="paragraph">{item.operator.name}</Typography>
      </div>
      <div className="flex items-center gap-2">
        <Button
          variant="custom"
          size="sm"
          startIcon="TickCircle"
          className="bg-success text-white hover:bg-success/90"
          disabled={isLoading}
          onClick={handleAccept}
        >
          Accept
        </Button>
        <Button
          variant="custom"
          size="sm"
          startIcon="CloseCircle"
          className="bg-danger text-white hover:bg-danger/90"
          disabled={isLoading}
          onClick={handleDecline}
        >
          Decline
        </Button>
      </div>
    </div>
  );
};
